import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Nav,
  Navbar,
  NavDropdown,
  Offcanvas,
} from "react-bootstrap";
import logo from "../../../assets/img/logo.png";
import { Link, useNavigate } from "react-router-dom";
import "./DashboradNavbar.css";
import { FaRegUserCircle } from "react-icons/fa";

const DashboardNavbar = () => {
  const navigate = useNavigate();
  const [hoveredDropdown, setHoveredDropdown] = useState(null);
  const handleMouseEnter = (id) => {
    if (window.innerWidth >= 992) {
      setHoveredDropdown(id);
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth >= 992) {
      setHoveredDropdown(null);
    }
  };
  const handleLogOut = (e) => {
    e.preventDefault();
    localStorage.setItem("isAdmin", JSON.stringify("false"));
    window.location.href = "/login  ";
  };
  useEffect(() => {
    console.log(localStorage.getItem("isAdmin"));
  }, []);

  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);
  return (
    <>
      <Navbar expand="lg" className="dashboard-nav fixed-top section-spacing-x">
        <Container fluid>
          <Navbar.Brand href="">
            <img src={logo} className="img-fluid" alt="shreeharidiamondlab" />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls={`offcanvasNavbar-expand-lg`}
            onClick={handleShow}
          />
          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-lg`}
            aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
            placement="end"
            show={showOffcanvas}
            onHide={handleClose}
          >
            <Offcanvas.Header closeButton className="offcanvas-header">
              <Offcanvas.Title
                id={`offcanvasNavbarLabel-expand-lg`}
                onClick={handleClose}
              >
                <img
                  src={logo}
                  className="img-fluid"
                  alt="shreeharidiamondlab"
                />
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="justify-content-end w-100">
                <div className="navbar-links d-flex flex-column flex-lg-row">
                  <Link
                    to="/admin/addcertificate"
                    className="nav-link"
                    onClick={handleClose}
                  >
                    Add Certificate
                  </Link>
                  <Link
                    to="/admin/certificatelist"
                    className="nav-link"
                    onClick={handleClose}
                  >
                    Certificate List
                  </Link>
                  <Link
                    to="/admin/enquirylist"
                    className="nav-link"
                    onClick={handleClose}
                  >
                    Enquiry List
                  </Link>
                </div>
                <NavDropdown
                  title={
                    <>
                      <span className="userprofilebtn">
                        <FaRegUserCircle />
                      </span>
                    </>
                  }
                  id={`profiledropdown`}
                  className="userdropmenu menudropdown d-none d-lg-flex align-items-center"
                  show={hoveredDropdown === "profiledropdown"}
                  onMouseEnter={() => handleMouseEnter("profiledropdown")}
                  onMouseLeave={handleMouseLeave}
                >
                  {/* <NavDropdown.Item href="#action3">Profile</NavDropdown.Item> */}
                  <NavDropdown.Item onClick={handleLogOut}>
                    Log Out
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
              <div className="d-lg-none p-2 fixed-bottom">
                <Button
                  variant="light"
                  onClick={handleLogOut}
                  className="w-100 offcan-logout-btn d-lg-none mt-auto"
                >
                  Log Out
                </Button>
              </div>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </>
  );
};

export default DashboardNavbar;
